import React, { useState } from 'react'
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import closeIcon from 'assets/images/close-icon.svg';
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from "assets/images";

const ConfirmationModal = ({ headerText, bodyText, mainText = null, setShowDeleteModal, confirmDelete }: any) => {
	const [isShow, setisShow] = useState(true);
	const onCloseModal = () => {
		setisShow(false);
	}
	return (
		<>
			<Modal className={"modal-wrapper max-w-[400px]"} isShow={setShowDeleteModal}>
				<div>

					{/* Modal bg Shade */}
					<img className="absolute top-0.5 left-0 object-contain -z-10" src={modalBgShade} alt="shade" />

					<HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-5 px-6">
						<img className="cursor-pointer w-12 h-12 mb-3.5" src={allImgPaths.deleteIcon5} alt="remove" />
						<div className="flex items-center justify-between pb-3">
							<h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">{headerText}</h2>
							{/* Close Icon */}
							<img
								className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-[120px]"
								id="modal-toggle"
								src={closeIcon}
								onClick={() => { setShowDeleteModal(false) }}
								alt="close icon"
							/>
						</div>
						{bodyText &&
							<p className='text-[#101828] pb-4'>{bodyText}</p>
						}
						<p className='text-[#101828]'>
							{
								mainText ? mainText : 'Are you sure you want to delete?'
							}
						</p>

					</HeaderModal>
					<Body title="" isShowBody={true} className="modal-body px-3 pt-1">
						<div className="modal-select-box fete-settings-modals">
						</div>
					</Body>

					<FooterModal title="" isShowFooter={true} className="modal-footer pt-7 px-6 pb-6">
						<div className="flex items-center gap-x-3 justify-center">
							<button onClick={confirmDelete} className="!text-base text-white bg-[#D92D20] hover:bg-[#B42318] font-interSemiBold rounded-lg px-3.5 py-2.5 flex-1">Yes, Delete</button></div>
					</FooterModal>
				</div>

			</Modal>
		</>
	)
}

export default ConfirmationModal;
